import React from "react"

export default (color: string) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="22"
    viewBox="0 0 25 22"
  >
    <path
      id="Polygon_1"
      data-name="Polygon 1"
      d="M9.022,6.121a4,4,0,0,1,6.956,0l5.627,9.9A4,4,0,0,1,18.127,22H6.873A4,4,0,0,1,3.4,16.024Z"
      transform="translate(25 22) rotate(180)"
      fill={`${color}`}
    />
  </svg>
)
